import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { BellRinging, CheckCircle } from "@phosphor-icons/react";

export function PriceAlertForm({ products, testid = "price-alert", compact = false }) {
  const [email, setEmail] = useState("");
  const [pid, setPid] = useState(products[0]?.id || "");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const [already, setAlready] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setState("saving");
    setError("");
    try {
      await api.post("/price-alerts", { email, product_id: pid }).then((r) => setAlready(!!r.data.already));
      setState("done");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Please enter a valid email");
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <div data-testid={`${testid}-success`} className="flex items-start gap-2 rounded-2xl bg-[#5B7B53]/10 text-[#465F41] p-4 text-sm">
        <CheckCircle size={18} weight="fill" className="shrink-0 mt-0.5" />
        <span>{already
          ? <>You're already watching this product with <b>{email}</b>. We'll email you when it drops 10% or more.</>
          : <>Done! We'll email <b>{email}</b> when the price drops 10% or more. Check your inbox for a confirmation.</>}</span>
      </div>
    );
  }
  return (
    <form data-testid={testid} onSubmit={submit} className={`rounded-2xl border border-[#E5E0D8] bg-white ${compact ? "p-4" : "p-5"}`}>
      <p className="flex items-center gap-2 font-semibold text-[#2C2B29] text-sm">
        <BellRinging size={18} weight="duotone" className="text-[#D17A58]" /> Waiting for a better price?
      </p>
      <p className="text-xs text-[#5C5A56] mt-1">Get a free email when it drops 10% or more. No spam, unsubscribe anytime.</p>
      {products.length > 1 && (
        <select data-testid={`${testid}-product`} value={pid} onChange={(e) => setPid(e.target.value)} className="mt-3 w-full px-3 py-2.5 rounded-full border border-[#E5E0D8] bg-white text-sm">
          {products.map((p) => <option key={p.id} value={p.id}>{p.title} — {p.price}</option>)}
        </select>
      )}
      <div className="mt-3 flex flex-col sm:flex-row gap-2">
        <input
          data-testid={`${testid}-email`}
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="flex-1 min-w-0 px-4 py-2.5 rounded-full border border-[#E5E0D8] bg-[#F9F8F6] text-sm focus:outline-none focus:ring-2 focus:ring-[#5B7B53]/30"
        />
        <button data-testid={`${testid}-submit`} disabled={state === "saving"} className="rounded-full px-5 py-2.5 text-sm font-semibold bg-[#2C2B29] text-white hover:bg-[#5B7B53] transition-colors disabled:opacity-50 whitespace-nowrap">
          {state === "saving" ? "Saving…" : "Alert me"}
        </button>
      </div>
      {error && <p data-testid={`${testid}-error`} className="text-xs text-[#B5613F] mt-2">{error}</p>}
    </form>
  );
}
